import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { CarouselService, CarouselView, EFAStateServiceService, ScreenView } from '../../shared';

@Component({
  selector: 'carousel-travel',
  template: `<poi-select-carousel selectedFilter="experience"></poi-select-carousel>`,
  host: { class: 'experience-finder-ai--host-carousel-experience experience-finder-ai--host-element experience-finder-ai--host-carousel' },
  viewProviders: [ CarouselService ],
  encapsulation: ViewEncapsulation.None
})
export class CarouselExperiencesComponent extends CarouselView implements OnInit {

  constructor(a: EFAStateServiceService, b: CarouselService) {
    super(a, b);
  }

  ngOnInit(): void {
    this.initialize(ScreenView.experienceCarousel, 'experience');
  }

}
